import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import { connect } from 'react-redux'

const ProtectedRoute = props => {
  const hasRole = role => role && props.currentRole === role

  const hasAuthority = auth => {
    if (auth === null) {
      return null
    }
    if (Array.isArray(auth)) {
      return !!auth.find(a => props.authorities.includes(a))
    }
    return props.authorities.indexOf(auth) >= 0
  }

  const hasAuthorityOrRole = (auth, role) => hasAuthority(auth) || hasRole(role)

  const getPage = () => {
    if (props.incompleteUser) {
      return <Redirect to="/edit-profile" />
    }
    if (props.selectStore) {
      return <Redirect to="/store/select" />
    }
    if (props.loggedIn) {
      if (hasAuthorityOrRole(props.authority, props.role)) {
        return props.page
      }
      return <Redirect to="/" />
    }
    return <Redirect to="/login" />
  }

  const _props = { ...props, render: () => getPage() }
  return <Route {..._props} />
}

ProtectedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  selectStore: PropTypes.bool.isRequired,
  page: PropTypes.object.isRequired,
  authorities: PropTypes.array.isRequired,
  authority: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  currentRole: PropTypes.string.isRequired,
  role: PropTypes.string,
  exact: PropTypes.bool,
  incompleteUser: PropTypes.bool.isRequired,
}

ProtectedRoute.defaultProps = {
  authority: null,
  role: null,
  exact: false,
}

const mapStateToProps = state => ({
  loggedIn: state.auth.isLoggedIn,
  selectStore: state.auth.selectStore,
  authorities: state.auth.authorities,
  currentRole: state.auth.role,
  incompleteUser: state.auth.incompleteUser,
})

export default connect(mapStateToProps, null)(ProtectedRoute)
